import { render, staticRenderFns } from "./DisableP2PSaveVoiceSetting.vue?vue&type=template&id=4078056f&scoped=true"
import script from "./DisableP2PSaveVoiceSetting.vue?vue&type=script&lang=js"
export * from "./DisableP2PSaveVoiceSetting.vue?vue&type=script&lang=js"
import style0 from "./DisableP2PSaveVoiceSetting.vue?vue&type=style&index=0&id=4078056f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4078056f",
  null
  
)

export default component.exports